export function createScript(url, nonce) {
    const firstElem = document.getElementsByTagName('script')[0];
    const elem = document.createElement('script');
    elem.async = true;
    if (Boolean(nonce)) elem.nonce = nonce;
    elem.src = url;
    firstElem.parentNode.insertBefore(elem, firstElem);
}

export function createTagManger(userSetting = '', nonce) {
    if (userSetting) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            if (Boolean(nonce)) j.setAttribute('nonce', nonce);
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', userSetting);
    }
}

/**
 * 為指定來源掛上 `<link rel="preconnect">`，提前把 DNS + TCP + TLS 做完（#86eyjp7qb）。
 *
 * 用於 host 會依環境變動、寫不進 public/index.html 的來源（如 API endpoint）。
 *
 * crossOrigin 必須與實際請求的 credentials mode 一致：瀏覽器的連線池是按 credentials mode
 * 分開的，標錯的話預熱的是另一條連線、等於白開，而且**完全靜默**——功能全正常，只是優化沒生效。
 * 同一個 origin 的兩種 mode 是兩條不同的連線，所以去重要連 crossOrigin 一起比對，否則第二條
 * 會被誤判成重複而擋掉。
 *
 * @param {string} origin - 要預先連線的來源，例如 'https://api.dev.feversocial.com'
 * @param {'anonymous' | 'use-credentials'} crossOrigin - 對應請求的 credentials mode。
 *   裸 fetch（credentials 用預設值，跨源時不帶憑證）用 'anonymous'；
 *   帶 `credentials: 'include'` 的請求用 'use-credentials'。
 */
export function createPreconnect(origin, crossOrigin = 'anonymous') {
    if (!origin) return;
    if (
        document.head.querySelector(
            `link[rel="preconnect"][href="${origin}"][crossorigin="${crossOrigin}"]`
        )
    )
        return;

    const elem = document.createElement('link');
    elem.rel = 'preconnect';
    elem.href = origin;
    elem.crossOrigin = crossOrigin;
    document.head.appendChild(elem);
}

export function createCSP(content) {
    const firstElem = document.getElementsByTagName('meta')[0];
    const elem = document.createElement('meta');
    elem.httpEquiv = 'Content-Security-Policy';
    elem.content = content;
    firstElem.parentNode.insertBefore(elem, firstElem);
}
